<template>
  <div id="products" class="w-full h-fit flex flex-col items-center gap-10 pb-28 py-10 px-[5vw]">
    <div class="flex flex-col items-center gap-5">
      <h4 class="text-2xl font-bold text-center">Our Featured Categories</h4>
      <p class="px-[5vw] max-lg:px-[5vw] max-lg:w-full text-center w-4/5 text-balance">
        These fruits are rich in essential vitamins and nutrients, contributing significantly to your overall health. In
        terms of date nutrition, their high fiber and carbohydrate content undoubtedly make them one of the healthiest
        dried fruits.
      </p>
    </div>

    <div class="w-full flex flex-col gap-20">
      <ProductContainer v-if="!loadingData" :isEmpty="!loadingData && favoriteCategories.length == 0"
        title="Special Products">
        <div v-if="!loadingData && favoriteCategories.length == 0"
          class="w-full flex justify-center items-center font-semibold text-lg">No featured categories.</div>
        <CategoryCard v-for="(category, index) in favoriteCategories" :key="category._id" :imageLink="images[index]"
          :categoryId="category._id" :name="category.name" :desc="category.description" :imgLoading="imgLoading" />
      </ProductContainer>

      <div v-if="loadingData && delayFinished" class="grid grid-cols-3 gap-5 max-lg:grid-cols-1">
        <div class="flex items-center justify-center flex-col h-[200px]">
          <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="3rem" height="3rem" viewBox="0 0 24 24">
            <defs>
              <linearGradient id="mingcuteLoadingFill0" x1="50%" x2="50%" y1="5.271%" y2="91.793%">
                <stop offset="0%" stop-color="#FFB908" />
                <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
              </linearGradient>
              <linearGradient id="mingcuteLoadingFill1" x1="50%" x2="50%" y1="15.24%" y2="87.15%">
                <stop offset="0%" stop-color="#FFB908" stop-opacity="0" />
                <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
              </linearGradient>
            </defs>
            <g fill="none">
              <path
                d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
              <path fill="url(#mingcuteLoadingFill0)"
                d="M8.749.021a1.5 1.5 0 0 1 .497 2.958A7.502 7.502 0 0 0 3 10.375a7.5 7.5 0 0 0 7.5 7.5v3c-5.799 0-10.5-4.7-10.5-10.5C0 5.23 3.726.865 8.749.021"
                transform="translate(1.5 1.625)" />
              <path fill="url(#mingcuteLoadingFill1)"
                d="M15.392 2.673a1.5 1.5 0 0 1 2.119-.115A10.475 10.475 0 0 1 21 10.375c0 5.8-4.701 10.5-10.5 10.5v-3a7.5 7.5 0 0 0 5.007-13.084a1.5 1.5 0 0 1-.115-2.118"
                transform="translate(1.5 1.625)" />
            </g>
          </svg>
        </div>

        <div class="flex items-center justify-center flex-col h-[200px] max-lg:hidden">
          <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="3rem" height="3rem" viewBox="0 0 24 24">
            <defs>
              <linearGradient id="mingcuteLoadingFill0" x1="50%" x2="50%" y1="5.271%" y2="91.793%">
                <stop offset="0%" stop-color="#FFB908" />
                <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
              </linearGradient>
              <linearGradient id="mingcuteLoadingFill1" x1="50%" x2="50%" y1="15.24%" y2="87.15%">
                <stop offset="0%" stop-color="#FFB908" stop-opacity="0" />
                <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
              </linearGradient>
            </defs>
            <g fill="none">
              <path
                d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
              <path fill="url(#mingcuteLoadingFill0)"
                d="M8.749.021a1.5 1.5 0 0 1 .497 2.958A7.502 7.502 0 0 0 3 10.375a7.5 7.5 0 0 0 7.5 7.5v3c-5.799 0-10.5-4.7-10.5-10.5C0 5.23 3.726.865 8.749.021"
                transform="translate(1.5 1.625)" />
              <path fill="url(#mingcuteLoadingFill1)"
                d="M15.392 2.673a1.5 1.5 0 0 1 2.119-.115A10.475 10.475 0 0 1 21 10.375c0 5.8-4.701 10.5-10.5 10.5v-3a7.5 7.5 0 0 0 5.007-13.084a1.5 1.5 0 0 1-.115-2.118"
                transform="translate(1.5 1.625)" />
            </g>
          </svg>
        </div>

        <div class="flex items-center justify-center flex-col h-[200px] max-lg:hidden">
          <svg class="animate-spin" xmlns="http://www.w3.org/2000/svg" width="3rem" height="3rem" viewBox="0 0 24 24">
            <defs>
              <linearGradient id="mingcuteLoadingFill0" x1="50%" x2="50%" y1="5.271%" y2="91.793%">
                <stop offset="0%" stop-color="#FFB908" />
                <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
              </linearGradient>
              <linearGradient id="mingcuteLoadingFill1" x1="50%" x2="50%" y1="15.24%" y2="87.15%">
                <stop offset="0%" stop-color="#FFB908" stop-opacity="0" />
                <stop offset="100%" stop-color="#FFB908" stop-opacity="0.55" />
              </linearGradient>
            </defs>
            <g fill="none">
              <path
                d="M24 0v24H0V0zM12.593 23.258l-.011.002l-.071.035l-.02.004l-.014-.004l-.071-.035c-.01-.004-.019-.001-.024.005l-.004.01l-.017.428l.005.02l.01.013l.104.074l.015.004l.012-.004l.104-.074l.012-.016l.004-.017l-.017-.427c-.002-.01-.009-.017-.017-.018m.265-.113l-.013.002l-.185.093l-.01.01l-.003.011l.018.43l.005.012l.008.007l.201.093c.012.004.023 0 .029-.008l.004-.014l-.034-.614c-.003-.012-.01-.02-.02-.022m-.715.002a.023.023 0 0 0-.027.006l-.006.014l-.034.614c0 .012.007.02.017.024l.015-.002l.201-.093l.01-.008l.004-.011l.017-.43l-.003-.012l-.01-.01z" />
              <path fill="url(#mingcuteLoadingFill0)"
                d="M8.749.021a1.5 1.5 0 0 1 .497 2.958A7.502 7.502 0 0 0 3 10.375a7.5 7.5 0 0 0 7.5 7.5v3c-5.799 0-10.5-4.7-10.5-10.5C0 5.23 3.726.865 8.749.021"
                transform="translate(1.5 1.625)" />
              <path fill="url(#mingcuteLoadingFill1)"
                d="M15.392 2.673a1.5 1.5 0 0 1 2.119-.115A10.475 10.475 0 0 1 21 10.375c0 5.8-4.701 10.5-10.5 10.5v-3a7.5 7.5 0 0 0 5.007-13.084a1.5 1.5 0 0 1-.115-2.118"
                transform="translate(1.5 1.625)" />
            </g>
          </svg>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import ProductContainer from "./ProductContainer.vue";
import CategoryCard from "./CategoryCard.vue";
import { ref, onMounted, computed, watch } from "vue";
import { fetchData } from "@/composables/fetchData";
import { fetchFile } from "@/composables/fetchFile.js"

const favoriteCategories = ref([]);

const { categories, loadingData, delayFinished, getData } = fetchData(() =>{
  favoriteCategories.value = categories.value.filter(category => category.isFeatured == true && category.status == "Posted")
})

const images = ref([]);
const imgLoading = ref(true);

watch(favoriteCategories, async (categories) => {
  imgLoading.value = true;
  if (Array.isArray(categories)) {
    const imagesPromises = categories.map((product) =>
      fetchFile({
        fileUrl: product.imgUrl,
        folderName: "categories",
      })
    );
    images.value = await Promise.all(imagesPromises);
    imgLoading.value = false;
  } else {
    images.value = [];
    imgLoading.value = false;
  }
}, { immediate: true });

onMounted(() => {
  getData()
})

</script>

<style>

</style>